import { useId, type ReactNode } from "react";
import { Link } from "react-router-dom";
import DirectionalIcon from "../../../features/navigation/DirectionalIcon.tsx";
import "./AccountEmptyState.css";

/** Full-height account surface; the feature supplies copy and its existing destination. */
export function AccountEmptyState({ pageTitle, title, description, icon, actionLabel, actionTo, hint }: {
  pageTitle: string;
  title: string;
  description?: string;
  icon: ReactNode;
  actionLabel: string;
  actionTo: string;
  hint: string;
}) {
  const titleId = useId();

  return (
    <section
      className="account-empty-state"
      aria-labelledby={titleId}
    >
      <header className="account-empty-state__header">
        <h1>{pageTitle}</h1>
      </header>
      <div className="account-empty-state__body">
        <div
          className="account-empty-state__icon"
          aria-hidden="true"
        >
          {icon}
        </div>
        <h2 id={titleId}>{title}</h2>
        {description ? (
          <p className="account-empty-state__description">{description}</p>
        ) : null}
        <Link
          to={actionTo}
          className="account-empty-state__action"
        >
          {actionLabel}
          <DirectionalIcon direction="forward" />
        </Link>
      </div>
      <footer className="account-empty-state__hint">
        {hint}
      </footer>
    </section>
  );
}
